import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subject } from 'rxjs';

// CONFIG
import { DialogConfig } from '../../../shared/configs/dialog.config';

// INTERFACES
import { trackById } from '../../../shared/util/track-by.util';
import { ICreditCard } from '../../interfaces/client-payment-profile.interface';

// UTILS

@Component({
  selector: 'lum-client-payment-profile-table',
  templateUrl: './client-payment-profile-table.component.html',
  styleUrls: ['./client-payment-profile-table.component.scss'],
})
export class ClientPaymentProfileTableComponent implements OnInit, OnDestroy {
  @Input()
  cards :ICreditCard[];

  @Output()
  setDefaultCardEvent = new EventEmitter<ICreditCard>();

  @Output()
  openPaymentProfileFormEvent = new EventEmitter<{
    card :ICreditCard;
    type :string;
  }>();

  trackById = trackById;

  private onDestroy$ = new Subject();

  constructor() {}

  ngOnInit() :void {}

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onSelectDefaultCard(card :ICreditCard) :void {
    this.setDefaultCardEvent.emit(card);
  }

  onManageCard(card :ICreditCard, type :string) :void {
    this.openPaymentProfileFormEvent.emit({ card, type });
  }
}
